import React from 'react';

const RatingExplainerPopup = ({ isOpen, onClose, explainer, timeLabel, daySummary }) => {
    if (!isOpen) return null;

    // If we have a day summary, show that instead of individual hour explanation
    if (daySummary) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                <div className="bg-custom-darker border border-custom-light-blue rounded-lg shadow-2xl max-w-2xl w-full p-6 animate-fade-in max-h-[80vh] overflow-y-auto">
                    
                    {/* Day Summary Header */}
                    <div className="mb-4 pb-4 border-b border-custom-charcoal">
                        <h2 className="text-lg font-bold text-custom-light-blue mb-1">
                            📊 Day Summary & Forecast Analysis
                        </h2>
                        <p className="text-xs text-custom-light-grey">
                            An overview of conditions throughout the day based on your preferences
                        </p>
                    </div>
                    
                    {/* Summary Content */}
                    <div className="text-sm text-custom-light-grey leading-relaxed whitespace-pre-line mb-6">
                        {daySummary}
                    </div>

                    {/* Close button */}
                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-6 py-2 rounded-md bg-custom-light-blue text-custom-dark font-medium hover:bg-custom-light-blue/90 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Original individual hour explanation
    if (!explainer) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-custom-darker border border-custom-light-blue rounded-lg shadow-2xl max-w-2xl w-full p-6 animate-fade-in max-h-[80vh] overflow-y-auto">
                
                {/* Score summary */}
                <div className="mb-4 pb-4 border-b border-custom-charcoal">
                    {timeLabel && (
                        <div className="text-xs text-custom-light-grey mb-2">
                            Rating breakdown for: <span className="font-semibold text-white">{timeLabel}</span>
                        </div>
                    )}
                    <h2 className="text-lg font-bold text-custom-light-blue mb-1">
                        {explainer.getScoreExplanation()}
                    </h2>
                </div>
                
                {/* Full explanation */}
                <div className="text-sm text-custom-light-grey leading-relaxed space-y-3 mb-6">
                    {explainer.getWaveHeightExplanation() && (
                        <div className="flex gap-2">
                            <span className="text-lg">📊</span>
                            <p className="flex-1">{explainer.getWaveHeightExplanation()}</p>
                        </div>
                    )}
                    {explainer.getSwellPeriodExplanation() && (
                        <div className="flex gap-2">
                            <span className="text-lg">⏱️</span>
                            <p className="flex-1">{explainer.getSwellPeriodExplanation()}</p>
                        </div>
                    )}
                    {explainer.getSwellDirectionExplanation() && (
                        <div className="flex gap-2">
                            <span className="text-lg">🌊</span>
                            <p className="flex-1">{explainer.getSwellDirectionExplanation()}</p>
                        </div>
                    )}
                    {explainer.getWindSpeedExplanation() && (
                        <div className="flex gap-2">
                            <span className="text-lg">💨</span>
                            <p className="flex-1">{explainer.getWindSpeedExplanation()}</p>
                        </div>
                    )}
                    {explainer.getWindDirectionExplanation() && (
                        <div className="flex gap-2">
                            <span className="text-lg">🧭</span>
                            <p className="flex-1">{explainer.getWindDirectionExplanation()}</p>
                        </div>
                    )}
                </div>

                {/* Close button */}
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 rounded-md bg-custom-light-blue text-custom-dark font-medium hover:bg-custom-light-blue/90 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RatingExplainerPopup;
